import { uniqueId } from 'lodash';
import { memo, useRef, type PropsWithChildren, type ReactNode } from 'react';

import { EFocusView } from './focusView.enum';
import {
  GeoMapProvider,
  type GeoMapProviderProps,
  type Padding,
} from './GeoMapProvider';
import { GlobeLayer } from './layers';

export interface GeoMapProps {
  // Projection configuration
  initialFocus: EFocusView;
  children?: ReactNode;
  padding?: Partial<Padding>;
  // Styling
  className?: string;
  /** Forwarded to GeoMapProvider; central widget passes false. */
  applyFocusZoomMultiplier?: boolean;
}

const GeoMapComponent = ({
  initialFocus = EFocusView.US_CONTINENTAL,
  children,
  padding,
  applyFocusZoomMultiplier,
}: PropsWithChildren<GeoMapProps>) => {
  const contextIdRef = useRef(uniqueId());
  const providerProps: GeoMapProviderProps = {
    initialFocus,
    contextId: contextIdRef.current,
    padding,
    applyFocusZoomMultiplier,
  };
  return (
    <GeoMapProvider {...providerProps}>
      <GlobeLayer />
      {children}
    </GeoMapProvider>
  );
};

export const GeoMap = memo(GeoMapComponent);
